import {Component, Emit, Prop, Vue} from "vue-property-decorator";

@Component({
})
export default class Popup extends Vue {
    @Prop()
    private value!: boolean;

    @Prop({
        default: () => 'fade'
    })
    private transition!: string;

    @Prop({
        default: () => false
    })
    private showOnHover!: boolean;

    @Prop({
        default: () => true
    })
    private closeOnBlur!: boolean;

    @Prop({
        default: () => 'right'
    })
    private position!: string;

    private on = {
        mouseover: () => {
            if (this.showOnHover) {
                this.isVisible = true;
            }
        },
        mouseout: () => {
            if (this.showOnHover) {
                this.isVisible = false;
            }
        },
        click: () => {
            this.isVisible = !this.isVisible;
        }
    }

    get isVisible() {
        return this.value;
    }

    set isVisible(value) {
        this.$emit('input', value);
    }
}
